import { render } from "./WysiwygBlock.vue?vue&type=template&id=0d8ce75a&scoped=true"
import script from "./WysiwygBlock.vue?vue&type=script&lang=js"
export * from "./WysiwygBlock.vue?vue&type=script&lang=js"

import "./WysiwygBlock.vue?vue&type=style&index=0&id=0d8ce75a&lang=scss&scoped=true"

import exportComponent from "/opt/project/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d8ce75a"]])

export default __exports__